import * as React from 'react'

// consider using https://github.com/xnimorz/use-debounce
export function useDebounce<T>(value: T, delay?: number): T {
  const [debouncedValue, setDebouncedValue] = React.useState<T>(value)

  React.useEffect(() => {
    const timer = setTimeout(() => setDebouncedValue(value), delay ?? 500)

    return () => {
      clearTimeout(timer)
    }
  }, [value, delay])

  return debouncedValue
}

export function useDebouncedCallback<T extends unknown[]>(
  callback: (...args: T) => void,
  delay = 500
): (...args: T) => void {
  const callbackRef = React.useRef(callback)
  callbackRef.current = callback
  const timerRef = React.useRef<ReturnType<typeof setTimeout> | null>(null)

  return React.useCallback(
    (...args: T) => {
      if (timerRef.current !== null) clearTimeout(timerRef.current)
      timerRef.current = setTimeout(() => {
        callbackRef.current(...args)
      }, delay)
    },
    [delay]
  )
}
